import { render, staticRenderFns } from "./GroupDescriptionForm.vue?vue&type=template&id=7c6ed697&scoped=true&lang=pug&"
import script from "./GroupDescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./GroupDescriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./GroupDescriptionForm.vue?vue&type=style&index=0&id=7c6ed697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6ed697",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCardText,VDivider})
